import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, get, sumBy, toArray } from 'lodash';
import { FontIcon } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { unitRender } from '../../../utils/normalize';

const itemStyle = {
  display: 'flex', alignItems: 'center', margin: 3
};
const iconStyle = { marginRight: 5 };
const textStyle = { width: '75px' };
const color = 'rgb(117, 117, 117)';

const ExpectedHours = ({
  entries,
  workingHours,
  start,
  workingDays,
}) => {
  const [expectedHours, setExpectedHours] = useState(0);
  const [workedHours, setWorkedHours] = useState(0);

  useEffect(() => {
    setWorkedHours(sumBy(toArray(entries), 'ActualClockTime'));
  }, [entries]);

  useEffect(() => {
    const workingHour = find(workingHours, h => moment(start).isSameOrAfter(get(h, 'Begda')) && moment(start).isSameOrBefore(get(h, 'Endda')));
    const hrsPerDay = get(workingHour, 'HrsPrDay', 0);

    setExpectedHours(hrsPerDay * workingDays);
  }, [start, workingHours]);

  return (
    <div style={{ display: 'flex' }}>
      <div style={itemStyle}>
        <FontIcon color={color} style={iconStyle} className="material-icons">schedule</FontIcon>
        <div style={textStyle}>
          <FormattedMessage id="time.hours" values={{ hours: unitRender(expectedHours - workedHours) }} tagName="div" />
          <span style={{ color }}><FormattedMessage id="time.TimeBehind" /></span>
        </div>
      </div>

      <div style={itemStyle}>
        <FontIcon color={color} style={iconStyle} className="material-icons"> done </FontIcon>
        <div style={textStyle}>
          <FormattedMessage id="time.hours" values={{ hours: unitRender(workedHours) }} tagName="div" />
          <span style={{ color }}><FormattedMessage id="time.workedHours" /></span>
        </div>
      </div>

      <div style={itemStyle}>
        <FontIcon color={color} style={iconStyle} className="material-icons">event_note</FontIcon>
        <div style={textStyle}>
          <FormattedMessage id="time.hours" values={{ hours: unitRender(expectedHours) }} tagName="div" />
          <span style={{ color }}><FormattedMessage id="time.expectedHours" /></span>
        </div>
      </div>
    </div>
  );
};
ExpectedHours.propTypes = {
  entries: PropTypes.shape({}).isRequired,
  workingHours: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  workingDays: PropTypes.number.isRequired,
  start: PropTypes.shape({}).isRequired,
};
ExpectedHours.defaultProps = {
};
export default connect(({ timeReducer }) => ({ ...timeReducer }))(ExpectedHours);



// WEBPACK FOOTER //
// ./src/sites/time/components/ExpectedHours.js